import { Theme } from '@mui/system'

export const theme2Components = {
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '200px'
        },
        sizeSmall: ({ theme }: { theme: Theme }) => ({
          padding: theme.spacing(1.5, 6)
        }),
        sizeMedium: ({ theme }: { theme: Theme }) => ({
          padding: theme.spacing(2, 8)
        }),
        sizeLarge: ({ theme }: { theme: Theme }) => ({
          padding: theme.spacing(2.5, 10)
        }),
        outlinedSizeSmall: ({ theme }: { theme: Theme }) => ({
          padding: `${theme.spacing(1.5)} calc(${theme.spacing(6)} - 1px)`
        }),
        outlinedSizeMedium: ({ theme }: { theme: Theme }) => ({
          padding: `${theme.spacing(2)} calc(${theme.spacing(8)} - 1px)`
        }),
        outlinedSizeLarge: ({ theme }: { theme: Theme }) => ({
          padding: `${theme.spacing(2.5)} calc(${theme.spacing(10)} - 1px)`
        })
      }
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          borderRadius: '200px'
        },
        multiline: {
          borderRadius: '16px'
        },
        input: {
          paddingLeft: '2rem !important',
          paddingRight: '2rem !important'
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        filled: {
          '&:not(.MuiInputLabel-shrink)': {
            transform: 'translate(2rem, 0.8rem) scale(1) !important'
          },
          '&.MuiInputLabel-shrink': {
            transform: 'translate(2rem, 0.2rem) scale(0.75) !important'
          }
        }
      }
    }
  }
}
